import urls from "../../../../../../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../../../../../../utils/service";

export async function addProjectFilterMeta(body: any) {
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.ADDPROJECTFILTERMETA, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getProjectFilterMeta(type?: any, search?: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETPROJECTFILTERMETA}?type=${type || ""}&search=${search || ""}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getProjectFilterFieldValues(field: string) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      `${urls.GETPROJECTFILTERFIELDVALUES}?field=${encodeURIComponent(field || "")}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function syncProjectFilterMetaFromProjects() {
  try {
    const callParams = await getCallParams("POST", {});
    const response = await makeCall(urls.SYNCPROJECTFILTERMETA, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function deleteProjectFilterMeta(id: string, body?: any) {
  try {
    const callParams = await getCallParams("DELETE", body);
    const response = await makeCall(urls.DELETEPROJECTFILTERMETA + id, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
